import { TranslationGroupConfig } from './translation-group.model';

export const translationGroupKeys = {
  welcomeScreen: 'welcome',
  thankYouPage: 'thankYouPage'
};

export const translationGroupConfig: TranslationGroupConfig[] = [
  { key: translationGroupKeys.welcomeScreen, name: 'Welcome screen' },
  { key: translationGroupKeys.thankYouPage, name: '"Thank you" Page' }
];
